import "./index.scss";

import { NavLink } from "react-router-dom";

const HeaderNav = () => {
  return (
    
    <div>
        <header>
            <div className="box-title">
            <h1>Academia StackX</h1>
            </div>
        </header>

        <nav>

            <div className="nav-itens">
            <NavLink to="/" className={({ isActive }) => (isActive ? "link ativo" : "link")}>Home</NavLink>
            </div>

            <div className="nav-itens">
            <NavLink to="/about" className={({ isActive }) => (isActive ? "link ativo" : "link")}>Sobre</NavLink>
            </div>

            <div className="nav-itens">
            <NavLink to="/planos" className={({ isActive }) => (isActive ? "link ativo" : "link")}>Planos</NavLink>
            </div>

            <span 
            className="register-btn">
            <NavLink to="/register" className={({ isActive }) => (isActive ? "link ativo" : "link")}>Inscreva-se</NavLink>
            </span>

        </nav>
    </div>
  );
};

export default HeaderNav;
